import styled from 'styled-components';

import BREAK_POINTS from '@soluto-home-web/platform-common-ui/styling/media-queries';

export default styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 28px;
  color: #1b1b1b;
  text-align: center;
  @media ${BREAK_POINTS.desktop} {
    text-align: left;
    font-size: 40px;
    line-height: 40px;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/CalculatorHeader.tsx